<template>
  <v-dialog v-model="dialog" width="600" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ 'app.menu.scale_menu' | trans }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="valid" lazy-validation>
          <v-container grid-list-md no-padding>
            <v-layout align-center justify-start row fill-height>
              <span class="menu-scale-label">{{ 'app.menu.scale_menu_from' | trans }} {{ currentDesiredDietEnergy }} kcal</span>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <span class="menu-scale-label">{{ 'app.menu.scale_menu_to' | trans }}</span>
              <div :style="{'width':'100px'}">
                <permission-tooltip
                    :permission="hasPermission('menu_schema_scale')"
                    :tooltip="{top: true, bottom: false, attach: false}"
                >
                  <v-text-field
                      :disabled="!hasPermission('menu_schema_scale')"
                      v-model="newDesiredDietEnergy"
                      full
                      :rules="rules.desired_diet_energy"
                      suffix="kcal"
                      type="number"
                  ></v-text-field>
                </permission-tooltip>
              </div>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <div :style="{'width':'225px'}">
                <permission-tooltip
                    :permission="hasPermission('menu_schema_scale')"
                    :tooltip="{top: true, bottom: false, attach: false}"
                >
                  <v-checkbox
                      :disabled="!hasPermission('menu_schema_scale')"
                      :color="`success`"
                      v-model="shouldRound"
                      :label="trans('app.menu.should_round')"
                  >
                  </v-checkbox>
                </permission-tooltip>
              </div>
              <div :style="{'width':'50px'}">
                <permission-tooltip
                    :permission="hasPermission('menu_schema_scale')"
                    :tooltip="{top: true, bottom: false, attach: false}"
                >
                  <v-text-field
                      :disabled="!hasPermission('menu_schema_scale') || !shouldRound"
                      v-model="roundValue"
                      :rules="rules.roundValue"
                      type="number"
                      step="0.25"
                      min="0.01"
                      max="1"
                      full
                  ></v-text-field>
                </permission-tooltip>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">help</v-icon>
                </template>
                <span>
                  {{ `app.menu.should_round_description` | trans }}
            </span>
              </v-tooltip>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <div :style="{'width':'400px'}">
                <permission-tooltip
                    :permission="hasPermission('menu_schema_scale')"
                    :tooltip="{top: true, bottom: false, attach: false}"
                >
                  <v-checkbox
                      :disabled="!hasPermission('menu_schema_scale')"
                      :color="`success`"
                      v-model="keepProportions"
                      :label="trans('app.menu.keep_proportions')"
                  >
                  </v-checkbox>
                </permission-tooltip>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">help</v-icon>
                </template>
                <span>
                  {{ 'app.menu.keep_proportions_description' | trans }}
                </span>
              </v-tooltip>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-alert
                  :value="true"
                  type="warning"
              >
                {{ 'app.menu.multi_portion_foods_warning' | trans }}
              </v-alert>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" :disabled="!valid || loading" :loading="loading"
               @click="save()">
          {{ 'app.import_template' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import RulesBuilder from "../../utils/rulesBuilder";
import {trans} from "../../app";
import {mapGetters} from "vuex";

export default {
  data: function () {
    return {
      patientId: null,
      schemaId: null,
      dialog: false,
      newDesiredDietEnergy: null,
      rulesBuilder: new RulesBuilder(),
      shouldRound: false,
      keepProportions: false,
      roundValue: 0.25,
      valid: false,
      loading: false,
      currentDesiredDietEnergy: null,
    }
  },
  computed: {
    ...mapGetters(['hasPermission']),
    rules: function () {
      return {
        desired_diet_energy: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.menu.desired_diet_energy_modal'))
              .addIsIntegerRule(trans('app.menu.desired_diet_energy_modal'))
              .addNumberBiggerThanRule(trans('app.menu.desired_diet_energy_modal'), 100)
              .getRules()
        ],
        round_value: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.menu.round_value'))
              .addIsNumericRule(trans('app.menu.round_value'))
              .addNumberBetweenRule(trans('app.menu.round_value'), 0.01, 1)
              .getRules()
        ]
      }
    },
  },
  methods: {
    open(patientId, schemaId, currentDesiredDietEnergy) {
      this.patientId = patientId;
      this.schemaId = schemaId;
      this.currentDesiredDietEnergy = currentDesiredDietEnergy;
      this.newDesiredDietEnergy = this.currentDesiredDietEnergy;
      this.dialog = true;
    },
    close() {
      this.newDesiredDietEnergy = null;
      this.currentDesiredDietEnergy = null;
      this.schemaId = null;
      this.patientId = null;
      this.dialog = false;
    },
    save() {
      if (!this.hasPermission('menu_schema_scale')) {
        this.importSchema();
        return;
      }
      this.$confirmWarning(trans('app.menu.confirm_scale')).then(() => {
        this.importSchema();
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
    },
    importSchema() {
      this.loading = true;
      axios.post(`/schemas/${this.patientId}/import`, {
        schema: this.schemaId,
        new_desired_diet_energy: this.newDesiredDietEnergy,
        should_round: this.shouldRound,
        keep_proportions: this.keepProportions,
        scale_products: this.hasPermission('menu_schema_scale'),
        round_value: parseFloat(this.roundValue),
      }).then((response) => {
        window.location.href = response.data.url;
      }).catch(() => {
        this.loading = false;
      });
    }
  }
}
</script>
<style scoped>
.menu-scale-label {
  margin: 0 10px;
}
</style>
